import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Observable} from "rxjs/Observable";
import 'rxjs/Rx';
import {Subscription} from "rxjs/Subscription";
import {HttpCommonService} from "../../services/http-common.service";
import {Router} from "@angular/router";
import {MyQueryHistoryService} from "../../services/my-query-history.service";

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() useClass = 0;// 使用样式 0首页 1大屏 2企业注册 4添加企业监测
  @Output() keyChoose: EventEmitter<Company> = new EventEmitter<Company>();// 输入框选则值后对外事件
  keyWord = '';// 输入框关键词
  oldKeyWord = '';// 输入框旧值
  companyList: Company[] = [];// 查询结果数组
  showResultDiv = false;// 是否收起结果下拉框
  isMouseOnResultDiv = false;// 鼠标是否在悬浮在结果下拉框上
  isFocus = false;// 角度是否在输入框上
  searchEventSub: Subscription;// 搜索事件流的订阅
  company: Company;// 传值
  isShowDeleteAll = false;// 是否显示删除历史的按钮

  constructor(private msg: NzMessageService,
              private confirmServ: NzModalService,
              private elementRef: ElementRef,
              private router: Router,
              private queryHisServ: MyQueryHistoryService,
              private http: HttpCommonService) {
  }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    //订阅输入框keyup事件流
    let inputEle = this.elementRef.nativeElement.querySelector('input');
    this.searchEventSub = Observable.fromEvent(inputEle, 'keyup')
      .debounceTime(400)
      .filter(e => e['keyCode'] != 13 && e['keyCode'] != 37 && e['keyCode'] != 38 && e['keyCode'] != 39 && e['keyCode'] != 40)
      .subscribe(e => {
        if (this.keyWord.trim() != this.oldKeyWord.trim()) {
          this.searchByKey();
        }
        this.oldKeyWord = this.keyWord;
      });
  }

  ngOnDestroy(): void {
    // 取消订阅，释放资源
    this.searchEventSub.unsubscribe();
  }

  /**
   * 输入框键盘事件
   */
  inputSomething(event: any) {
    if (event.keyCode == 13) {// enter
      this.toSearchPage(this.companyList.find(company => company.isHighlight));
    } else if (event.keyCode == 38) {// 上
      if (!this.keyWord) {
        return;
      }
      let index = this.companyList.findIndex(company => company.isHighlight);
      if (index == -1) {
        this.companyList[this.companyList.length - 1].isHighlight = true;
        this.keyWord = this.companyList[this.companyList.length - 1].companyName;
      } else if (index == 0) {
        this.companyList[index].isHighlight = false;
        this.keyWord = this.oldKeyWord;
      } else {
        this.companyList[index].isHighlight = false;
        this.companyList[index - 1].isHighlight = true;
        this.keyWord = this.companyList[index - 1].companyName;
      }
    } else if (event.keyCode == 40) {// 下
      if (!this.keyWord) {
        return;
      }
      let index = this.companyList.findIndex(company => company.isHighlight);
      if (index == -1) {
        this.companyList[0].isHighlight = true;
        this.keyWord = this.companyList[0].companyName;
      } else if (index == this.companyList.length - 1) {
        this.companyList[index].isHighlight = false;
        this.keyWord = this.oldKeyWord;
      } else {
        this.companyList[index].isHighlight = false;
        this.companyList[index + 1].isHighlight = true;
        this.keyWord = this.companyList[index + 1].companyName;
      }
    } else {
      this.companyList = [];
    }
  }

  /* 针对主页(forIndex)的输入框的特殊处理 begin */
  /*enterTimer: any;//
  isMouseOnInput: boolean = false;// 鼠标是否在input上
  inputEnterForIndex() {// 输入框鼠标移入
    this.isMouseOnInput = true;
    this.enterTimer = setTimeout(() => {
      this.showResultDiv = true;
      this.searchByKey();
    }, 800);
  }

  inputLeaveForIndex() {// 输入框鼠标移出
    this.isMouseOnInput = false;
    clearTimeout(this.enterTimer);
    setTimeout(() => this.showResultDiv = this.isMouseOnResultDiv, 0);
  }

  divLeaveForIndex() {// 结果框鼠标移出
    setTimeout(() => {
      this.isMouseOnResultDiv = this.isMouseOnInput;
      this.inputLeaveForIndex();
    }, 0);
  }

  inputFocusForIndex(event){
    $(event.target).trigger('hover');
  }*/

  /* 针对主页(forIndex)的输入框的特殊处理 end */


  /**
   * 清除所有的高亮显示
   */
  clearHighlight() {
    this.companyList = this.companyList.map(company => {
      company.isHighlight = false;
      return company;
    });
  }

  /**
   * 响应式查询
   */
  searchByKey() {
    if (!this.keyWord) {
      if (this.useClass == 0) {// 首页(不输入关键词则展示搜素历史)
        this.companyList = [];
        this.queryHisServ.getQueryHistory('').subscribe(
          result => {
            if (result.data && result.data.length > 0) {
              result.data.forEach((item, i) => {
                if (i < 4) {
                  this.companyList.push(new Company(item, '-1'));
                }
              });
              this.isShowDeleteAll = true;
            }
          });
      }
      return;
    }
    if (this.useClass == 0) {// 首页搜素
      // OperName1表示后台需要根据关键词匹配企业名称或者法定代表人,isFromIndex为1表示调用该接口的是首页
      this.http.get('/enterprise/detail/xhsRest/search/companySearch', {companyName: this.keyWord, OperName: '1', isFromIndex: '1'})
        .subscribe(result => {
          this.companyList = [];
          this.isShowDeleteAll = false;
          if (result.stateCode == '50001') {
            this.queryHisServ.getQueryHistory(this.keyWord).subscribe(
              result1 => {
                if (result1.data && result1.data.length > 0) {
                  result1.data.forEach((item, i) => {
                    if (i <= 1) {
                      this.companyList.push(new Company(item, '-1'));
                    }
                  });
                  this.isShowDeleteAll = true;
                }
                let returnData = result.data.returnData;
                let maxLength = 0;
                if (returnData.length > 4 - this.companyList.length) {
                  maxLength = 4 - this.companyList.length;
                } else {
                  maxLength = returnData.length;
                }
                for (let i = 0; i < maxLength; i++) {
                  this.companyList.push(new Company(returnData[i], this.useClass));
                }
              });

          } else if (result.stateCode == '50103') {
            this.msg.error("请输入更详细的关键词");
          } else if (result.stateCode == '50002') {
            this.msg.error("查询失败");
          }
        });
    } else {
      this.http.get('/user/center/xhsRest/getEnterpriseInfo', {companyName: this.keyWord})
        .subscribe(result => {
          this.companyList = [];
          if (result.stateCode == '1') {
            result.data.forEach(item => this.companyList.push(new Company(item, this.useClass)));
          }
        });
    }
  }

  /**
   * 跳转查询
   */
  toSearchPage(company?: Company) {
    /*if (!this.keyWord) {
      this.msg.error("请输入关键词");
      return;
    }*/
    this.showResultDiv = false;
    if (this.useClass == 2 || this.useClass == 3 || this.useClass == 4 || this.useClass == 5) {//企业注册或者报告下载或者企业监测
      this.company = company;
      if (this.useClass == 4) {
        this.keyWord = '';
        this.showResultDiv = this.isFocus = true;
        this.isMouseOnResultDiv = false;
        this.keyChoose.emit(this.company);
      }
      return;
    }
    if (company) {
      if (company.isHistory) {
        this.router.navigate(['/searchParent'], {queryParams: {keyWord: company.companyName}});
      } else {
        //添加搜索历史
        this.queryHisServ.addQueryHistory(this.keyWord).subscribe(result => {
        });
        this.router.navigate(['/enterpBasicArchives'], {queryParams: {companyId: company.id}});
      }
    } else {
      this.router.navigate(['/searchParent'], {queryParams: {keyWord: this.keyWord}});
    }

    /*this.confirmServ.confirm({
      title: '标题',
      content: '<b>跳转查询页面，keyword:' + this.keyWord + '</b>',
      onOk() {
      },
      onCancel() {
      }
    });*/
  }

  /**
   * 删除查询历史
   * @param id
   */
  deleteQueryHistory(queryContent, event) {
    event.stopPropagation();
    this.companyList = this.companyList.filter(item => item.companyName != queryContent);
    this.isShowDeleteAll = this.companyList.findIndex(item => item.isHistory) != -1;
    this.queryHisServ.deleteQueryHistory(queryContent).subscribe(result => {
    });
  }

  /**
   * 删除全部查询历史
   */
  deleteAllHistory(event) {
    event.stopPropagation();
    this.companyList = this.companyList.filter(item => !item.isHistory);
    this.isShowDeleteAll = false;
    this.queryHisServ.deleteAllHistory().subscribe(result => {
    });

  }

  /*/!**
   * 跳转到企业档案
   *!/
  toEnterInfo(company?: Company) {
    if (!this.keyWord) {
      this.msg.error("请输入关键词");
      return;
    }

    this.router.navigate(['enterpIntroduction/enterpBasicArchives'], {queryParams: {companyId: company.id}});
  }*/
}


export class Company {
  public id: string;
  public companyName: string;// 公司名
  public creditCode: string;// 统一社会信用码
  public legalPerson: string;// 法定代表人
  public establishmentDate: Date;// 成立日期
  public address: string;// 地址
  public authStatus: string;// 入驻状态 1，2未入驻、3已入驻
  public authStatusDesc: string;// 入驻状态中文
  public isHighlight: boolean;// 所在行样式
  public isHistory: boolean = false;// 所在行样式
  constructor(item: any, type) {
    if (type == '0') {// 首页
      this.id = item._id;
      this.companyName = item.name;
      this.creditCode = item.creditCode;
      this.establishmentDate = item.startDate;
      this.address = item.address;
    } else if (type == '-1') {// 历史
      this.id = item.ID;
      this.companyName = item.QUERY_CONTENT;
      this.isHistory = true;
    } else {
      this.id = item.companyId;
      this.companyName = item.companyName;
      this.creditCode = item.creditCode;
      this.legalPerson = item.legalPerson;
      this.establishmentDate = item.establishmentDate;
      this.address = item.address;
      this.authStatus = item.authStatus;
      if (item.authStatus == '1' || item.authStatus == '2') {
        this.authStatusDesc = '未入驻';
      } else if (item.authStatus == '3') {
        this.authStatusDesc = '已入驻';
      }
    }
    this.isHighlight = false;
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/search-box/search-box.component.ts